import React from 'react';
import moment from 'moment'

const MyFlowsStatistics = (props) => {

  const [statistics] = React.useState(props.statistics)

  return (
    statistics ?
    <span>
       Executions: <i>{statistics.countStart}</i>; Blocks: <i>{statistics.count}</i>; first run: <i>{moment(statistics.first_execution).fromNow()}</i>; last run: <i>{moment(statistics.last_execution).fromNow()}</i>
    </span> 
    : <span><br/></span>
  )
}

export default MyFlowsStatistics